module.exports = __webpack_public_path__ + "img/pro-info-img3.338ac891.png";